import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './reticle-dev';
import { installZoomGuard } from './utils/zoomGuard';

// ── Phase 13 · Lock app zoom ──────────────────────────────────────────────────
// iOS Safari ignores viewport `user-scalable=no`; utils/zoomGuard blocks pinch and
// double-tap-to-zoom at the document level, leaving controls (and the lightbox) alone.
installZoomGuard();

// ── Stale-chunk recovery ──────────────────────────────────────────────────────
// After a new deploy, code running in an open tab may try to lazy-load a JS
// chunk whose hashed filename no longer exists on the server → ChunkLoadError →
// blank screen. Reload once to pull the fresh index.html + chunks. The 10s guard
// prevents an infinite reload loop if the failure is something else persistent.
function recoverFromStaleChunk(err) {
  const name = err && err.name;
  const msg = (err && err.message) || '';
  const isChunkError =
    name === 'ChunkLoadError' ||
    /Loading chunk [\w-]+ failed/i.test(msg) ||
    /Loading CSS chunk [\w-]+ failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /importing a module script failed/i.test(msg);
  if (!isChunkError) return;
  try {
    const last = Number(sessionStorage.getItem('chunkReloadAt')) || 0;
    if (Date.now() - last > 10000) {
      sessionStorage.setItem('chunkReloadAt', String(Date.now()));
      window.location.reload();
    }
  } catch {
    window.location.reload();
  }
}
window.addEventListener('error', (e) => recoverFromStaleChunk(e.error || e));
window.addEventListener('unhandledrejection', (e) => recoverFromStaleChunk(e.reason));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  // Take over as soon as a new build is installed.
  //
  // registerValidSW already listens for controllerchange and reloads, and the
  // worker itself already handles a SKIP_WAITING message — but nothing sent one.
  // register() was called with no config, so the onUpdate branch that was
  // supposed to trigger this could never run: the new worker installed, went to
  // waiting, and stayed there until every tab of the site closed. On a phone
  // that is approximately never, so a returning user kept running the bundle
  // from whenever they first opened the app, and every deploy looked like it
  // hadn't happened.
  onUpdate: (registration) => {
    const next = registration.waiting || registration.installing;
    if (next) next.postMessage({ type: 'SKIP_WAITING' });
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
